import { render, staticRenderFns } from "./dateDiff.vue?vue&type=template&id=22f7b0de&"
import script from "./dateDiff.vue?vue&type=script&lang=js&"
export * from "./dateDiff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports